import { PlacesMap } from '../types';

const baseUrl = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}`;
const headers: HeadersInit = { Authorization: `Bearer ${process.env.REACT_APP_API_KEY}` };

export const getMap = (id: string) =>
  fetch(`${baseUrl}/location/maps/${id}`, { headers }).then(res => res.json()) as Promise<PlacesMap>;
